import * as loadingActionsType from '@/constants/loadingActionsType';

const initialState = {
  isShowRecoveryLoading: false,
  showLoading: false,
  loadingText: undefined,
  loadingClickEvent: undefined,
  loadingButton1: undefined,
  loadingButton2: undefined,
};

export default function loadingStore(state = initialState, action = {}) {
  switch (action.type) {
    case loadingActionsType.SHOW_RECOVERY_LOADING:
      return {...state, isShowRecoveryLoading: action.value};

    case loadingActionsType.SHOW_LOADING:
      return {...state, showLoading: action.value, loadingText: 'Loading...'};

    case loadingActionsType.UPDATE_LOADING:
      return {
        ...state,
        showLoading: action.value.showLoading,
        loadingText: action.value.loadingText,
        loadingClickEvent: action.value.loadingClickEvent,
        loadingButton1: action.value.loadingButton1,
        loadingButton2: action.value.loadingButton2,
      };

    case loadingActionsType.UPDATE_LOADING_TEXT:
      return {
        ...state,
        loadingText: action.value,
      };

    default:
      return state;
  }
}
